import { CommonModule } from '@angular/common';
import { Component, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { ConnectivityService } from '../../service/connectivity.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnDestroy {
  private readonly router = inject(Router);
  readonly auth = inject(AuthService);
  private readonly connectivity = inject(ConnectivityService);
  private readonly connectivitySubscription: Subscription;

  isOnline = this.connectivity.currentOnline;

  constructor() {
    this.connectivitySubscription = this.connectivity.isOnline$.subscribe((isOnline) => {
      this.isOnline = isOnline;
    });
  }

  ngOnDestroy(): void {
    this.connectivitySubscription.unsubscribe();
  }

  goHome(): void {
    void this.router.navigateByUrl('/');
  }

  showReleaseNotes(): void {
    window.dispatchEvent(new Event('tops:show-whats-new'));
  }

  showUserMenu(): void {
    window.dispatchEvent(new Event('tops:show-user-menu'));
  }

  signOut(): void {
    void this.auth.logout();
  }
}
